import K from "./constants";
import restHelpers from "../helpers/restHelper";

const getServiceTypes = plate => restHelpers.withBearer.get(`${K.SERVICING_URL}/api/intervalli?plate=${plate}`, {});

const getSequences = linkId => restHelpers.withBearer.get(`${K.SERVICING_URL}/api/intervalli?linkId=${linkId}`, {});

export default {
  getServiceTypes,
  getSequences
};



// WEBPACK FOOTER //
// ./src/services/servicing.js